module.exports = __webpack_public_path__ + "img/calendar-line.e1dc3e9d.svg";